import type { JSX } from "solid-js";
import type { SignalModule } from "../../enums/scan";
import type { WebsiteContext } from "../website/store";
import { ScanTopBar } from "./ScanTopBar";

/** Chrome for module routes that own the full width (no Scan side rail). */
export function ModuleShell(props: {
  context: WebsiteContext;
  activeModule: SignalModule | "none";
  workspaceClass?: string;
  children: JSX.Element;
}) {
  return (
    <div class="signal-app">
      <ScanTopBar context={props.context} activeModule={props.activeModule} />
      <main class={props.workspaceClass ?? "signal-workspace"}>
        {props.children}
      </main>
    </div>
  );
}
